import apiRoutes from '@constants/apiRoutes';
import baseApi from '@services/api';
import { ApiResponse, PaginatedResponse } from './types/common';
import {
  AdminPvxPartnersListingRequest,
  AdminPvxPartnersListingItem,
  PvxPartnerDetailsPayload,
  AdminCreatePvxPartnerResponse,
  PvxPartnerDashboardsResponse,
  PvxPartnerUpdateDashboardsRequest,
  PvxPartnerFilterEntitlementsRequest,
  EditPvxPartnerProfileRequest,
  PvxPartnerProfileApiResponse,
  FilterEntitlement,
} from './types/pvxPartners';
import { buildQueryParams } from '../utils/query';

const pvxPartners = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPvxPartners: builder.query<
      PaginatedResponse<AdminPvxPartnersListingItem>,
      AdminPvxPartnersListingRequest
    >({
      query: ({ pageNumber, pageSize, search, sort, sortOrder, role, status, partnerType }) =>
        `${apiRoutes.pvxPartners}?${buildQueryParams(
          { pageNumber, pageSize, search, sort, sortOrder },
          { role, status, partnerType },
        )}`,
    }),

    createPvxPartner: builder.mutation<
      ApiResponse<AdminCreatePvxPartnerResponse>,
      PvxPartnerDetailsPayload
    >({
      query: (body) => ({
        url: apiRoutes.pvxPartners,
        method: 'POST',
        body,
      }),
    }),

    getPvxPartnerDashboards: builder.query<ApiResponse<PvxPartnerDashboardsResponse>, string>({
      query: (clientCode) => apiRoutes.pvxPartnerDashboards(clientCode),
    }),

    updatePvxPartnerDashboards: builder.mutation<
      ApiResponse<null>,
      PvxPartnerUpdateDashboardsRequest
    >({
      query: ({ clientCode, submoduleIds }) => ({
        url: apiRoutes.pvxPartnerDashboards(clientCode),
        method: 'PUT',
        body: { submoduleIds },
      }),
    }),

    updatePvxPartnerFilterEntitlements: builder.mutation<
      ApiResponse<null>,
      PvxPartnerFilterEntitlementsRequest
    >({
      query: ({ clientCode, filters }) => ({
        url: apiRoutes.pvxPartnerFilterEntitlements(clientCode),
        method: 'PUT',
        body: filters,
      }),
    }),

    getPvxPartnerProfile: builder.query<ApiResponse<PvxPartnerProfileApiResponse>, string>({
      query: (clientCode) => apiRoutes.pvxPartnerProfile(clientCode),
    }),

    updatePvxPartnerProfile: builder.mutation<ApiResponse<null>, EditPvxPartnerProfileRequest>({
      query: ({ clientCode, ...body }) => ({
        url: apiRoutes.pvxPartnerProfile(clientCode),
        method: 'PUT',
        body,
      }),
    }),

    getPvxPartnerFilterEntitlements: builder.query<ApiResponse<FilterEntitlement[]>, string>({
      query: (clientCode) => apiRoutes.pvxPartnerFilterEntitlements(clientCode),
    }),
  }),
});

export const {
  useGetPvxPartnersQuery,
  useLazyGetPvxPartnersQuery,
  useCreatePvxPartnerMutation,
  useGetPvxPartnerDashboardsQuery,
  useLazyGetPvxPartnerDashboardsQuery,
  useUpdatePvxPartnerDashboardsMutation,
  useUpdatePvxPartnerFilterEntitlementsMutation,
  useGetPvxPartnerProfileQuery,
  useLazyGetPvxPartnerProfileQuery,
  useUpdatePvxPartnerProfileMutation,
  useGetPvxPartnerFilterEntitlementsQuery,
} = pvxPartners;
